module.exports = __webpack_public_path__ + "static/sunset-c545cb7dc699e5b3e68b5fe969f4e5e8.jpg";